<div class="content" *ngIf="!refresh">
    <div class="top">
        <div class="image-container">
            <app-employee-image *ngIf="user$" class="profile-pic" [employeeId]="user$.userId" round="true" width="200" height="200"></app-employee-image>
            <button 
                mat-mini-fab 
                color="primary" 
                setColor
                [setColorRules]="[
                {
                    color: 'primaryColour',
                    style: 'background'
                }
                ]" 
                class="edit-button"
                appPreventDoubleClick (throttledClick)="openFormDialog()">
                <mat-icon class="material-icons-outlined">edit</mat-icon>
            </button>
        </div>
    </div>
</div>